export default {
  en: {
    games: {
      baccarat: "Baccarat",
      baccarat_insurance: "Baccarat Insurance",
      dragontiger: "Dragon Tiger",
      dragon_tiger: "Dragon Tiger",
      hilohitech: "Sic Bo",
      hilo_hitech: "Sic Bo",
      hilo_local: "Hi-Lo Classic",
      keno: "Keno",
      roulette: "Roulette",
      sport_soccer: "Sport Soccer",
      sport_soccer_parlay: "Sport Soccer Parlay",
      lotto_poipet: "Poipet Lotto",
      keno_classic: "Keno Classic",
      money_wheel: "Money Wheel",
      pokdeng: "Pokdeng",
      hooheyhow: "Hoo Hey How",
      fantan: "Fan Tan"
    },
    messages: {
      round: "Round",
      limit: "Limit {limit}",
      admin: "Admin",
      main: "SP1",
      master: "SP2",
      agent: "Dealer",
      playNow: "Play now",
      bettime: "Time {time} seconds",
      userOnline: "Online {count}",
      break: "Break Time",
      remaining_chip: "Chip Balance",
      credit_chip: "Credit Chip",
      rolling_chip: "Rolling Chip",
      copied: "Copied.",
      timeDepositIntelligentReset:
        "Cancellations can be made after {minute} minutes.",
      depositInMinute: "You have a transfer time of {minute} minutes.",
      balanceMustBeDeposit: "The balance must be transferred.",
      specify_decimal: "* Please specify the decimal.",
      specify_bankAccount: "* Please specify the Account.",
      specify_transfer_time: "* Specify transfer time",
      deposit_guild_condition:
        '<h2><span class="text-danger">* โปรดอ่านขั้นตอนการแจ้งเติมเครดิต ในรูปแบบใหม่</span></h2>' +
        "<ol>" +
        "<li>กด เลือกธนาคารที่ต้องการโอน</li>" +
        "<li>กด ระบุจำนวนเงินที่ต้องการโอน แล้วกด ตกลง</li>" +
        '<li>ระบบจะแจ้งให้โอนเงินตามจำนวนที่ระบุ <span class="text-primary">(โดยระบบจะสุ่มตัวเลข เพิ่มจุดทศนิยม 2 ตำแหน่ง ต่อท้ายยอดเต็มที่สมาชิกระบุ)</span></li>' +
        '<li><span class="text-primary">ให้สมาชิกโอนยอดเงินตามที่ระบบกำหนดให้ โดยต้องโอนยอดมีเลขทศนิยม 2 ตำแหน่ง ที่ระบบระบุต่อท้ายด้วยทุกครั้ง </span><span class="text-primary">(เน้นย้ำ สำคัญมาก หากไม่โอนยอดที่มีจุดทศนิยม จะไม่สามารถปรับยอดได้)</span></li>' +
        '<li><span class="text-primary">ระบบจะมีระยะเวลาในการทำรายการ {minute} นาที โดยนับถอยหลัง เริ่มตั้งแต่ที่สมาชิกกดระบุยอดเงิน แล้วกด ตกลง</span></li>' +
        '<li><span class="text-primary">หากโอนเงินแล้ว ไม่สามารถทำรายการได้ทัน {minute} นาทีตามที่ระบบกำหนด หรือมีการทำรายการใดๆผิด ให้ติดต่อดีลเลอร์ทันที</span></li>' +
        '<li><span class="text-primary">กดแจ้ง เวลาฝาก โดยระบุ ชั่วโมง นาที ให้ตรงตามข้อมูลโมบายแบงค์กิ้ง หรือในใบสลิป</span></li>' +
        "<li>กด ระบุหมายเหตุ หากต้องการส่งข้อความใดๆถึงดีลเลอร์ (หากไม่ต้องการ สามารถข้ามการใส่ข้อมูลในช่องนี้ได้)</li>" +
        "<li>กด เติมเครดิต</li>" +
        "</ol>"
    },
    form: {
      request: {
        deposit: "Deposit",
        bank: {
          notfound: "Bank Not Found"
        },
        ok: "Ok"
      },
      cancel: "Cancel",
      bank_name: "Bank",
      acc_name: "Account",
      acc_no: "Account number",
      bank_acc: "Bank account",
      amount: "Amount",
      date: "Date",
      time: "Time",
      time_a: "",
      remark: "Remark",
      title: {
        select_account_transfer: "Transfer Wallet",
        select_account_deposit: "Choose Bank",
        transfer_with_qrcode: "Transfer via QR Code"
      },
      published: "Published"
    },
    navigator: {
      prev: "Prev",
      next: "Next"
    }
  },
  th: {
    games: {
      baccarat: "บาคาร่า",
      baccarat_insurance: "บาคาร่าประกันภัย",
      dragontiger: "เสือมังกร",
      dragon_tiger: "เสือมังกร",
      hilohitech: "ซิกโบ",
      hilo_hitech: "ซิกโบ",
      hilo_local: "ไฮโลพื้นบ้าน",
      keno: "คีโน่",
      roulette: "รูเล็ต",
      sport_soccer: "เดิมพันบอลตั๋ว",
      sport_soccer_parlay: "เดิมพันบอลชุด",
      lotto_poipet: "ปอยเปตล็อตโต้",
      keno_classic: "คีโน่ คลาสสิค",
      money_wheel: "วงล้อพาโชค",
      pokdeng: "ป๊อกเด้ง",
      hilo_local: "ไฮโล คลาสสิค",
      hooheyhow: "น้ำเต้า ปู ปลา",
      fantan: "กำถั่ว"
    },
    messages: {
      round: "ตาที่",
      admin: "Admin",
      main: "SP1",
      master: "SP2",
      agent: "ดีลเลอร์",
      limit: "จำกัด {limit}",
      playNow: "เล่นเกมส์",
      bettime: "เวลา {time} วินาที",
      userOnline: "ออนไลน์ {count}",
      break: "ช่วงพัก",
      remaining_chip: "จำนวนชิปคงเหลือ",
      credit_chip: "ชิปเป็น",
      rolling_chip: "ชิปตาย",
      copied: "ทำการ copy เรียบร้อย",
      depositInMinute: "คุณมีเวลาโอนเงินภายในเวลา {minute} นาที",
      balanceMustBeDeposit: "ยอดที่ต้องโอนคือ",
      specify_decimal: "* โปรดระบุเศษให้ถูกต้อง",
      specify_bankAccount: "* บัญชีที่ต้องโอน",
      specify_transfer_time: "* ระบุเวลาที่โอน",
      timeDepositIntelligentReset: "สามารถยกเลิกได้หลังจากผ่านไป {minute} นาที",
      deposit_guild_condition:
        '<h2><span class="text-danger">* โปรดอ่านขั้นตอนการแจ้งเติมเครดิต ในรูปแบบใหม่</span></h2>' +
        "<ol>" +
        "<li>กด เลือกธนาคารที่ต้องการโอน</li>" +
        "<li>กด ระบุจำนวนเงินที่ต้องการโอน แล้วกด ตกลง</li>" +
        '<li>ระบบจะแจ้งให้โอนเงินตามจำนวนที่ระบุ <span class="text-primary">(โดยระบบจะสุ่มตัวเลข เพิ่มจุดทศนิยม 2 ตำแหน่ง ต่อท้ายยอดเต็มที่สมาชิกระบุ)</span></li>' +
        '<li><span class="text-primary">ให้สมาชิกโอนยอดเงินตามที่ระบบกำหนดให้ โดยต้องโอนยอดมีเลขทศนิยม 2 ตำแหน่ง ที่ระบบระบุต่อท้ายด้วยทุกครั้ง </span><span class="text-primary">(เน้นย้ำ สำคัญมาก หากไม่โอนยอดที่มีจุดทศนิยม จะไม่สามารถปรับยอดได้)</span></li>' +
        '<li><span class="text-primary">ระบบจะมีระยะเวลาในการทำรายการ {minute} นาที โดยนับถอยหลัง เริ่มตั้งแต่ที่สมาชิกกดระบุยอดเงิน แล้วกด ตกลง</span></li>' +
        '<li><span class="text-primary">หากโอนเงินแล้ว ไม่สามารถทำรายการได้ทัน {minute} นาทีตามที่ระบบกำหนด หรือมีการทำรายการใดๆผิด ให้ติดต่อดีลเลอร์ทันที</span></li>' +
        '<li><span class="text-primary">กดแจ้ง เวลาฝาก โดยระบุ ชั่วโมง นาที ให้ตรงตามข้อมูลโมบายแบงค์กิ้ง หรือในใบสลิป</span></li>' +
        "<li>กด ระบุหมายเหตุ หากต้องการส่งข้อความใดๆถึงดีลเลอร์ (หากไม่ต้องการ สามารถข้ามการใส่ข้อมูลในช่องนี้ได้)</li>" +
        "<li>กด เติมเครดิต</li>" +
        "</ol>"
    },
    form: {
      transfer_wallet: "ยืนยันการย้ายเงิน",
      request: {
        deposit: "เติมเครดิต",
        ok: "ตกลง",
        bank: {
          notfound: "ไม่พบบัญชีธนาคาร"
        }
      },
      cancel: "ยกเลิก",
      acc_name: "ชื่อบัญชี",
      acc_no: "เลขบัญชี",
      bank_acc: "ธนาคาร",
      amount: "จำนวนเงิน",
      date: "วันที่",
      time: "เวลา",
      time_a: "น.",
      remark: "ข้อความหมายเหตุ",
      title: {
        select_account_transfer: "ย้ายกระเป๋าเงิน",
        select_account_deposit: "เลือกธนาคาร",
        transfer_with_qrcode: "โอนเงินผ่าน QR Code"
      },
      published: "เผยแพร่"
    },
    navigator: {
      prev: "กลับ",
      next: "ต่อไป"
    }
  },
  kh: {
    games: {
      baccarat: "Baccarat",
      baccarat_insurance: "Baccarat Insurance",
      dragontiger: "Dragon Tiger",
      dragon_tiger: "Dragon Tiger",
      hilohitech: "Sic Bo",
      hilo_hitech: "Sic Bo",
      hilo_local: "Hi-Lo Classic",
      keno: "Keno",
      roulette: "Roulette",
      sport_soccer: "Sport Soccer",
      sport_soccer_parlay: "Sport Soccer Parlay",
      lotto_poipet: "Poipet Lotto",
      keno_classic: "Keno Classic",
      money_wheel: "Money Wheel",
      pokdeng: "Pokdeng",
      hooheyhow: "Hoo Hey How",
      fantan: "Fan Tan"
    },
    messages: {
      round: "Round",
      limit: "Limit {limit}",
      playNow: "Play now",
      bettime: "Time {time} seconds",
      userOnline: "Online {count}",
      break: "Break Time",
      remaining_chip: "Chip Balance",
      credit_chip: "Credit Chip",
      rolling_chip: "Rolling Chip",
      timeDepositIntelligentReset:
        "Cancellations can be made after {minute} minutes.",
      depositInMinute: "You have a transfer time of {minute} minutes.",
      balanceMustBeDeposit: "The balance must be transferred.",
      specify_decimal: "* Please specify the decimal.",
      specify_bankAccount: "* Please specify the Account.",
      specify_transfer_time: "* Specify transfer time",
      deposit_guild_condition:
        '<h2><span class="text-danger">* โปรดอ่านขั้นตอนการแจ้งเติมเครดิต ในรูปแบบใหม่</span></h2>' +
        "<ol>" +
        "<li>กด เลือกธนาคารที่ต้องการโอน</li>" +
        "<li>กด ระบุจำนวนเงินที่ต้องการโอน แล้วกด ตกลง</li>" +
        '<li>ระบบจะแจ้งให้โอนเงินตามจำนวนที่ระบุ <span class="text-primary">(โดยระบบจะสุ่มตัวเลข เพิ่มจุดทศนิยม 2 ตำแหน่ง ต่อท้ายยอดเต็มที่สมาชิกระบุ)</span></li>' +
        '<li><span class="text-primary">ให้สมาชิกโอนยอดเงินตามที่ระบบกำหนดให้ โดยต้องโอนยอดมีเลขทศนิยม 2 ตำแหน่ง ที่ระบบระบุต่อท้ายด้วยทุกครั้ง </span><span class="text-primary">(เน้นย้ำ สำคัญมาก หากไม่โอนยอดที่มีจุดทศนิยม จะไม่สามารถปรับยอดใช้งานได้)</span></li>' +
        '<li><span class="text-primary">ระบบจะมีระยะเวลาในการทำรายการ {minute} นาที โดยนับถอยหลัง เริ่มตั้งแต่ที่สมาชิกกดระบุยอดเงิน แล้วกด ตกลง</span></li>' +
        '<li><span class="text-primary">หากโอนเงินแล้ว ไม่สามารถทำรายการได้ทัน {minute} นาทีตามที่ระบบกำหนด หรือมีการทำรายการผิดใดๆ ให้ติดต่อดีลเลอร์ทันที</span></li>' +
        '<li><span class="text-primary">กดแจ้ง เวลาฝาก โดยระบุ ชั่วโมง นาที ให้ตรงตามข้อมูลโมบายแบงค์กิ้ง หรือในใบสลิป</span></li>' +
        "<li>กด ระบุหมายเหตุ หากต้องการส่งข้อความใดๆถึงดีลเลอร์ (หากไม่ต้องการ สามารถข้ามการใส่ข้อมูลในช่องนี้ได้)</li>" +
        "<li>กด เติมเครดิต</li>" +
        "</ol>"
    },
    form: {
      request: {
        transfer_wallet: "Confirm Transfer",
        deposit: "Deposit",
        bank: {
          notfound: "Bank Not Found"
        },
        ok: "Ok"
      },
      cancel: "Cancel",
      bank_name: "Bank",
      acc_name: "Account",
      acc_no: "Account number",
      bank_acc: "Bank account",
      amount: "Amount",
      date: "Date",
      time: "Time",
      time_a: "",
      remark: "Remark",
      title: {
        select_account_deposit: "Choose Bank"
      },
      published: "Published"
    },
    navigator: {
      prev: "Prev",
      next: "Next"
    }
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/messages/system.js